<template>
  <b-container fluid class="liquidation-page">
    
    <b-row class="">
      <b-col cols="12">
        <b-card>
          <b-row class="align-items-center justify-content-between">
            
            <b-col cols="12" md="4" lg="3">
              <DateFilter
                v-model="selectedDate"
                @search="fetchLiquidation"
              />
            </b-col>
            
            <b-col cols="12" md="8" lg="6" class="d-flex align-items-center justify-content-md-end mt-3 mt-md-0">
              
              <ExcelButton 
                :items="items" 
                :details="details" 
                :totals="totals" 
                :selected-date="selectedDate" 
              />
            <div class="total-card shadow-sm ml-3">
              <div class="total-icon-wrapper">
                <i class="fas fa-wallet total-icon"></i>
              </div>
              <div class="total-content">
                <span class="total-label">Valor Total</span>
                <h3 class="total-value">
                  {{ formatValue(totals.totalAmount) }}
                </h3>
              </div>
            </div>

            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row >
      <b-col cols="12">
        <b-card>
          <b-row class="g-2">
            <b-col cols="6" md="3" sm="3">
              <DebitButton @click="selectAction('debito')" />
            </b-col>
            <b-col cols="6" md="3" sm="3">
              <CreditButton @click="selectAction('credito')" />
            </b-col>
            <b-col cols="6" md="3" sm="3">
              <ManualAnticipationButton
                @click="selectAction('antecipacao')"
              />
            </b-col>
            <b-col cols="6" md="3" sm="3">
              <AutomaticAntecipationButton @click="selectAction('outro')" />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <b-row >
      <b-col cols="12">
        <TotalArrangementTable :items="items" :is-loading="isLoading" :no-data-message="noDataMessage" />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <DetailTable :details="details" :is-loading="isLoading" :no-data-message="noDataMessage" />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { BContainer, BRow, BCol, BCard } from "bootstrap-vue";
import { formatValue } from "@/utils";
import DateFilter from "./components/DateFilter.vue";
import CreditButton from "./components/CreditButton.vue";
import DebitButton from "./components/DebitButton.vue";
import ManualAnticipationButton from "./components/ManualAnticipationButton.vue";
import AutomaticAntecipationButton from "./components/AutomaticAntecipationButton.vue";
import TotalArrangementTable from "./components/TotalArrangemetTable.vue";
import DetailTable from "./components/DetailTable.vue";
import LiquidationService from "@/service/liquidation";
import ExcelButton from "./components/ExcelButton.vue";

export default {
  name: "Liquidation",
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    DateFilter,
    CreditButton,
    DebitButton,
    ManualAnticipationButton,
    AutomaticAntecipationButton,
    TotalArrangementTable,
    DetailTable,
    ExcelButton,
  },
  data() {
    return {
      selectedDate: new Date().toISOString().substr(0, 10),
      selectedAction: "",
      items: [],
      details: [],
      totals: {}, 
      isLoading: false,
      noDataMessage: "",
    };
  },
  computed: {
    selectedActionLabel() {
      const labels = {
        credito: "Crédito",
        debito: "Débito",
        antecipacao: "Antecipação",
        outro: "Outro",
      };
      return labels[this.selectedAction] || "";
    },
  },
  mounted() {
    this.fetchLiquidation();
  },
  methods: {
    async fetchLiquidation() {
      this.items = [];
      this.details = [];
      this.totals = {}; 
      this.isLoading = true;
      this.noDataMessage = "";
      try {
        const response = await LiquidationService.getLiquidation({
          date: this.selectedDate,
        });
        this.items = response.data.matrix.rows || [];
        this.details = response.data.data || [];
        this.totals = response.data.matrix.totals || {}; 
        
        if (this.items.length === 0 ) {
          this.noDataMessage = `Nenhum dado encontrado para a data ${this.selectedDate}`;
          this.$toast.warning(this.noDataMessage);
        } else {
          this.$toast.success("Dados carregados com sucesso!");
        }
      } catch (err) {
        console.error(err);
        this.noDataMessage = "Erro ao carregar dados. Tente novamente.";
        this.$toast.error(this.noDataMessage);
      } finally {
        this.isLoading = false;
      }
    },

    selectAction(action) {
      this.selectedAction = action;
      this.fetchLiquidation();
    },
    formatValue(value) {
      if (value === null || value === undefined) return "-";
      return formatValue(value);
    }
  },
};
</script>


<style scoped>
.total-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 10px 20px;
  min-width: 210px;
  display: flex;
  align-items: center;
  gap: 14px;
  transition: all 0.3s ease;
}

.total-card:hover {
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.total-icon-wrapper {
  background-color: #ecedfd;
  color: var(--primary);
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.total-icon {
  font-size: 1.2rem;
}

.total-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.total-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.total-value {
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a; 
  margin: 0;
  line-height: 1.2;
}
</style>